export const CONSTANTS = {
	RESETALL: Symbol("Events/ResetAll")
};

export const initialState = {
	events: null,
	isLoading: {
		all: false,
		rates: false,
		category: false
	}
};

/**
 * Reducer managing contingent.
 *
 * @name EventReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		switch (action.type) {
			case CONSTANTS.RESETALL:
				return initialState;
			default:
				return state;
		}
	}

	return action.performEventReducer(state);
};
